var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Banner } from "./..";
import styled from "../../styled";
var NotificationWrapper = styled(function (props) { return React.createElement(Banner, __assign({}, props)); })(function (_a) {
    var theme = _a.theme;
    return "\n      animation-duration: 300ms;\n      animation-fill-mode: both;\n      animation-name: fadeInUp;\n      animation-timing-function: ease-in;\n     \n      & + & {\n        margin-top: " + theme.space.lg + ";\n      }\n      \n      @keyframes fadeInUp {\n        from {\n          opacity: 0;\n          transform: translateY(10px);\n        }\n      \n        to {\n          opacity: 1;\n        }\n      }\n    ";
});
export var Notification = function (_a) {
    var _b = _a.autoDismissSeconds, autoDismissSeconds = _b === void 0 ? 3 : _b, _c = _a.autoDismisses, autoDismisses = _c === void 0 ? true : _c, _d = _a.palette, palette = _d === void 0 ? 'primary' : _d, _e = _a.isDismissable, isDismissable = _e === void 0 ? true : _e, id = _a.id, children = _a.children, onDismiss = _a.onDismiss;
    React.useEffect(function () {
        var timer;
        var stopAutoDismissTimer = function () {
            return clearTimeout(timer);
        };
        var startAutoDismissTimer = function () {
            if (!autoDismisses || !isDismissable)
                return;
            timer = setTimeout(function () { return onDismiss && onDismiss(); }, autoDismissSeconds * 1000);
        };
        if (autoDismisses) {
            startAutoDismissTimer();
        }
        else {
            stopAutoDismissTimer();
        }
    });
    return (React.createElement(NotificationWrapper, { id: id, palette: palette, isDismissable: isDismissable, onDismiss: onDismiss, lss: {
            textAlign: 'left',
            textScale: 'control',
            borderRadius: 'sm',
            boxShadow: 'lg'
        } }, children));
};
//# sourceMappingURL=Notifications.js.map